import IconModule from './icon.module'

export default IconModule
